import { CloseOutlined, DeleteOutlined, FilterOutlined, SaveOutlined, UserAddOutlined, WarningOutlined } from "@ant-design/icons";
import { Modal, Select } from "antd";
import '../styles.scss';

import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { memo, useEffect, useState } from 'react';
import { addCustomerByGroup, addFilter, addListGroup, addOperatorFilterGroup, getInfoOperatorFieldConditionsGroup, getListAllCustomer, getListCustomer_V2BySync, getListOperatorFieldConditionsGroup, getListOperatorFieldValueGroup, IConditionADDAPI, IConditionSV2, IDetailGroup, IGroup, IOperatorFieldGroup, IOperatorFieldGroupV2, IVConditionFilterADD, IVConditionFilterV2 } from "../../../api/groupCustomerV2/groupCustomerV2Api";
import { getSLlistFilter, ISelectOption } from "../../../api/selectOptions/selectOptionsApi";
import useDebounce from "../../../hook/useDebounce";
import { mapToSelectOptions } from "../../../until";
import { AddType, CONDITION, ConditionGroup, ISelectedCustomer, limitSyncListCustomerGroupByFilter } from "../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup";
import { CONDITIONGROUP } from "../../Customers/CustomerGroup/Component/AddGroup/Component/PrivateGroup/AG_PrivateAutomatic";
import ConditionGroupAnd from "../../Customers/CustomerGroup/Component/AddGroup/Component/SharingGroup/components/ConditionGroupAnd";
import ConditionGroupOther from "../../Customers/CustomerGroup/Component/AddGroup/Component/SharingGroup/components/ConditionGroupOther";
import ModalSaveFilter from "../../Customers/CustomerGroup/Component/Modal/ModalSaveFilter";
import { IDataDefaulFilterList, OptionData, TYPECONDITION } from "../indexV2";
import ModalSaveFilterAndCreatGroup from "./ModalSaveFilterAndCreatGroup";
import { filterInfoOperator, initInfoOperator, toAddPayload } from "../../Customers/CustomerGroup/Component/Modal/ModalAddAndEditCondition";
import useThrottle from "../../../hook/useThrottle";
import { useSelector } from "react-redux";
import { selectorInfoUser } from "../../../store/slices/infoUserSlice";
import { GROUPTYPE } from "../../Customers/CustomerGroup/Component/EditGroup/EditGroup";
import useToast from "../../../hook/useToast";
import { NodeEvent } from "../../Customers/CustomerGroup/Component/SideBar";
import { useNavigate } from "react-router-dom";
import { filterInfoOperatoToConditions } from "../../../apiSync/customerGroup/customerGroupApi";
import { selectorCategoryCarIds } from "../../../store/slices/categoryCarSlice";
import { convertNationwideTree } from "../../../api/unit/unitApi";
import { BATCH_SIZE } from "../../../env";

dayjs.locale('vi');

interface ModalProps {
  isOpen: boolean
  options: OptionData[]
  selectableOptions: OptionData[]
  sLListFilter: ISelectOption[]

  dataFilterList: IDataDefaulFilterList
  inforGroup?: IDetailGroup
  infoOperator: IVConditionFilterV2

  setIsModalFilterList: (e: boolean) => void
  setDataFilterList: (value: IDataDefaulFilterList) => void
  setInfoOperator: React.Dispatch<React.SetStateAction<IVConditionFilterV2>>
  setSearchListFilter: (e: string) => void

  onSubmitFormModal: (iSsuccess: boolean, message?: string) => void
  closeModal: (e: boolean) => void

}

const ModalCondition: React.FC<ModalProps> = ({
  isOpen,
  options, selectableOptions, sLListFilter,
  dataFilterList, infoOperator, inforGroup,
  setIsModalFilterList, setDataFilterList, setInfoOperator, setSearchListFilter,
  onSubmitFormModal, closeModal
}) => {
  const pushToast = useToast();
  const navigate = useNavigate()
  const { unitTemp } = useSelector(selectorInfoUser)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const [isModalSaveFilter, setModalSaveFilter] = useState<boolean>(false)
  const [isModalSaveFilterAndCreatGroup, setModalSaveFilterAndCreatGroup] = useState<boolean>(false)

  const [infoOperatorTmp, setInfoOperatorTmp] = useState<IVConditionFilterV2>(initInfoOperator)


  const gInfoOperatorFieldConditionsGroup = useDebounce(async (id?: number) => {
    if (!id) return
    const result = await getInfoOperatorFieldConditionsGroup(id)
    if (result?.status) {
      if (result.data?.id) {
        setInfoOperatorTmp(result.data)
        gListOperatorFieldConditionsGroupByInfo(result.data?.conditions)
      } else {
        setInfoOperatorTmp(initInfoOperator)
      }
    }
  }, 500)


  //sL diều kiện
  const gListOperatorFieldConditionsGroupByInfo = useDebounce(
    async (conditions: IConditionSV2[]) => {
      if (!Array.isArray(conditions) || conditions.length === 0) return;

      const nextConditions = await Promise.all(
        conditions.map(async (cond) => {
          const fieldId = cond.CustomerField?.value;
          const inputType = cond.CustomerField?.inputType;
          if (!fieldId) return cond;

          try {
            // Luôn gọi lấy conditionData
            const operatorPromise = getListOperatorFieldConditionsGroup(fieldId).then((rs) =>
              rs?.status && Array.isArray(rs.data) ? mapToSelectOptions(rs.data) : []
            );

            // Nếu là dropdown thì gọi thêm fetchDropdownOptions
            const dropdownPromise =
              inputType === "dropdown" ? fetchDropdownOptions(fieldId, cond.condition?.value) : Promise.resolve([]);

            const [conditionData, optionsData] = await Promise.all([
              operatorPromise,
              dropdownPromise,
            ]);

            return {
              ...cond,
              isAdd: true,
              conditionData,
              ...(inputType === "dropdown" ? { optionsData } : {}),
            };
          } catch {
            return cond;
          }
        })
      );

      setInfoOperatorTmp((prev) => ({
        ...prev,
        conditions: nextConditions,
      }));
    },
    500
  );

  //Lấy data Dropdown
  const fetchDropdownOptions = async (fieldId: number, conditioId?: number): Promise<ISelectOption[] | undefined> => {
    if (!conditioId) return undefined
    try {
      const conditions = filterInfoOperatoToConditions(infoOperatorTmp)
      const rs = await getListOperatorFieldValueGroup(
        fieldId, conditioId, conditions, unitTemp
      );
      if (rs?.status && Array.isArray(rs.data.value)) {
        if (rs.data.type) {
          return convertNationwideTree(rs.data.value ?? []); // ép kiểu về ISelectOption
        } else {
          return rs.data.value as ISelectOption[]; // ép kiểu về ISelectOption
        }
      }
    } catch (e) {
      // Có thể log lỗi hoặc xử lý theo ý bạn
      console.error("Lỗi fetchDropdownOptions:", e);
    }
    return undefined;
  };

  const handleChangeSLlistFilter = (id?: number) => {
    if (id) {
      gInfoOperatorFieldConditionsGroup(id)
    } else {
      setInfoOperatorTmp(initInfoOperator)
    }
  }

  const handleChangeTypeCondition = (id: 0 | 1 | 2) => {
    setInfoOperatorTmp({
      ...initInfoOperator,
      typeCondition: id
    })
  }

  const handelReset = () => {
    closeModal(false)
    setInfoOperatorTmp(initInfoOperator)
    setInfoOperator(initInfoOperator)
  }

  const handelOpenModalName = () => {
    const filteredInfoOperatorADD = toAddPayload(infoOperatorTmp, undefined, TYPECONDITION.CUSTOMER)
    if (!filteredInfoOperatorADD.conditions.length) {
      onSubmitFormModal(false, "Chưa có điều kiện nào thỏa mãn!")
      return
    }

    setModalSaveFilter(true)
  }

  const handelSaveFilter = async (title: string) => {
    const filteredInfoOperatorADD = toAddPayload(infoOperatorTmp, title, TYPECONDITION.CUSTOMER)
    const result = await addFilter(
      [filteredInfoOperatorADD]
    )
    if (result?.status) {
      onSubmitFormModal(true, result.message)
      setModalSaveFilter(false)
      setIsModalFilterList(false)
      setInfoOperator({
        ...infoOperator,
        id: result.data.id
      })
    } else {
      onSubmitFormModal(false, result?.message)
    }
  }

  const onSubmitFormModalSaveFilterAndCreatGroup = async (value: any) => {
    const { title, isAddCondition } = value

    let selectedIdCustomerTmp: ISelectedCustomer[] = []
    const conditions = filterInfoOperatoToConditions(infoOperator)
    const result = await getListAllCustomer(
      permittedCategoryCarIds,
      unitTemp, conditions, undefined, undefined
    )
    if (result?.status) {
      // Tạm ẩn do thiếu api
      selectedIdCustomerTmp = result.data


    } else {
      pushToast(result?.message, "error")
      return
    }

    if (isAddCondition) {
      handelSaveFilter(title)
    }

    // addGroup(title, matchedCustomersSelectId)
    addGroup(title, selectedIdCustomerTmp)
  }



  const addCustomersInChunks = async (selectedIdCustomerV9: ISelectedCustomer[], idGroup: number) => {
    for (let i = 0; i < selectedIdCustomerV9.length; i += BATCH_SIZE) {
      const chunk = selectedIdCustomerV9.slice(i, i + BATCH_SIZE);

      let success = false;
      let retryCount = 0;

      while (!success) {
        try {
          await addCustomerByGroup(chunk, idGroup);
          success = true;
        } catch (error) {
          retryCount++;

          // delay trước khi retry
          await new Promise(r => setTimeout(r, 1000));
        }
      }

      // delay giữa các batch
      await new Promise(r => setTimeout(r, 50));
    }
  };



  // const addGroup = async (title: string, matchedCustomersSelectId: number[]) => {
  const addGroup = useThrottle(async (title: string, selectedIdCustomerTmp: ISelectedCustomer[]) => {

    const unitTempTmp = unitTemp ?? undefined
    const level = 1
    const typeTmp = CONDITION.YES

    // Tạm ẩn do thiếu api
    const result = await addListGroup(
      title, typeTmp, GROUPTYPE.PRIVATE,
      // selectedIdCustomerTmp,
      unitTempTmp, level, 0, undefined, undefined, selectedIdCustomerTmp.length ?? 0

    )
    // tài thêm api riêng
    if (result?.status) {
      aOperatorFilterGroup(result.data)
      await addCustomersInChunks(
        selectedIdCustomerTmp, result.data.id
      )

      pushToast(result?.message, "success")


    } else {
      pushToast(result?.message, "error")
    }
  }, 1000)

  const aOperatorFilterGroup = useThrottle(async (data: IGroup) => {
    const filteredInfoOperatorADD = toAddPayload(infoOperator)
    const { id, title, level, parentId, children } = data

    const inforNodeEvent: NodeEvent = {
      action: "view",
      item: {
        key: id.toString(),
        title,
        level,
        parentId,
        children: [],
      }
    }

    const listFilterGroup: IVConditionFilterADD = {
      typeCondition: filteredInfoOperatorADD.typeCondition,
      conditions: filteredInfoOperatorADD.conditions
    };

    const result = await addOperatorFilterGroup(
      id, [listFilterGroup]
    )
    if (result?.status) {
      pushToast(result?.message, "success")

      navigate("/customer/group", {
        state: {
          nodeEvent: inforNodeEvent,
        },
      });
    } else {
      pushToast(result?.message, "error")
    }
  }, 1000)


  const applyFilterCondition = async () => {
    const infoOperatorApply = filterInfoOperator(infoOperatorTmp)



    if (infoOperatorTmp.typeCondition === CONDITIONGROUP.ALL) {
      closeModal(false)
      setIsModalFilterList(false)
      return
    }

    if (infoOperatorApply?.conditions?.length) {
      setInfoOperator(infoOperatorApply)

      setDataFilterList({ ...dataFilterList, filterCustomerId: infoOperatorApply.id });
      closeModal(false)

      setIsModalFilterList(false)
    } else {
      onSubmitFormModal(false, "Chưa có điều kiện nào thỏa mãn!")
    }
  }


  const applyFilterConditionAndCreatGroup = () => {
    const infoOperatorApply = filterInfoOperator(infoOperatorTmp)
    if (infoOperatorTmp.typeCondition === CONDITIONGROUP.ALL) {
      setModalSaveFilterAndCreatGroup(true)
      closeModal(false)
      return
    }


    if (infoOperatorApply?.conditions?.length) {
      setModalSaveFilterAndCreatGroup(true)
      setInfoOperator(infoOperatorApply)
      closeModal(false)
    } else {
      onSubmitFormModal(false, "Chưa có điều kiện nào thỏa mãn!")
    }
  }




  const closeModalCondition = () => {
    closeModal(false);
    setInfoOperatorTmp(initInfoOperator)
  }

  //Dùng cho trường hợp cập nhật
  useEffect(() => {
    if (inforGroup?.infoFilter) {
      gListOperatorFieldConditionsGroupByInfo(inforGroup.infoFilter.conditions)
    }
  }, [inforGroup?.infoFilter])

  useEffect(() => {
    if (isOpen) {
      setInfoOperatorTmp(infoOperator)

      if (dataFilterList?.idDetailFilter) {
        gInfoOperatorFieldConditionsGroup(dataFilterList?.idDetailFilter)
      }
    }
  }, [isOpen])
  return (
    <>
      <ModalSaveFilter
        isOpen={isModalSaveFilter}

        handelSaveFilter={handelSaveFilter}
        closeModal={setModalSaveFilter}
      />
      <ModalSaveFilterAndCreatGroup
        isOpen={isModalSaveFilterAndCreatGroup}
        onSubmitFormModal={onSubmitFormModalSaveFilterAndCreatGroup}
        closeModal={setModalSaveFilterAndCreatGroup}
      />

      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className=" custom-page-css text-344054 text-lg  font-medium">Thiết lập điều kiện</span>
          <CloseOutlined className="text-base text-8B8B8B"
            onClick={() => closeModal(false)}
          />
        </div>}
        open={isOpen}
        onCancel={closeModalCondition}
        centered
        className="w-modal-V2 custom-page-css overflow-hidden modal-content-addCustomer ant-modal-size rounded"
        closeIcon={false}
        footer={
          <div className="custom-page-css w-full flex items-center justify-end gap-2 h-auto py-2 px-4">
            {/* isAdd = true | Cond = All */}
            {infoOperatorTmp.conditions[0].isAdd &&

              <div className={`   border-F5222D custom-page-css flex items-center gap-2 rounded px-2 py-2 cursor-pointer`}
                onClick={handelReset}
              >
                <DeleteOutlined className="custom-page-css text-FF4D4F text-sm" />
                <span className={` custom-page-css text-FF4D4F text-base  font-regular`}>Xoá bộ lọc</span>
              </div>
            }
            {infoOperatorTmp.typeCondition !== CONDITIONGROUP.ALL &&
              <div className={`   border-096DD9 custom-page-css flex items-center gap-2 rounded px-2 py-2 cursor-pointer`}
                onClick={handelOpenModalName}
              >
                <SaveOutlined className="custom-page-css text-096DD9 text-sm" />
                <span className={` custom-page-css text-096DD9 text-base  font-regular`}>Lưu</span>
              </div>
            }
            <div className={`   border-096DD9 custom-page-css flex items-center gap-2 rounded px-2 py-2 cursor-pointer`}
              onClick={applyFilterCondition}
            >
              <FilterOutlined className="custom-page-css text-096DD9 text-sm" />
              <span className={` custom-page-css text-096DD9 text-base  font-regular`}>Áp dụng lọc</span>
            </div>
            <div className={`  bg-096DD9 border-096DD9 custom-page-css flex items-center gap-2 rounded px-2 py-2 cursor-pointer`}
              onClick={applyFilterConditionAndCreatGroup}
            >
              <UserAddOutlined className="custom-page-css text-white text-sm" />
              <span className={` custom-page-css text-white text-base  font-regular`}>Áp dụng lọc và tạo nhóm</span>
            </div>

          </div>
        }
      >
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4 rounded">
          <div className="custom-page-css w-full flex gap-2 items-center justify-between">
            <span className='custom-page-css text-lg text-344054 font-medium'>Điều kiện nhóm</span>
            <div className="custom-page-css flex items-center gap-2 justify-end">
              <WarningOutlined className='text-FF4D4F' />
              <span className='custom-page-css text-base text-FF4D4F font-regular'>(Danh sách khách hàng sẽ thay đổi theo điều kiện)</span>

            </div>

          </div>
          <div className="custom-page-css w-full flex items-center gap-2">
            <div className="custom-page-css flex flex-col gap-2 flex-1 ">
              <span className='custom-page-css text-base text-344054 font-regular'>Logic kết hợp các điều kiện lọc</span>
              <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
                <div className="d-flex align-center  w-full">
                  <Select
                    showSearch={false}
                    allowClear
                    className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                    popupClassName='position-dropdow custome-select-item h-popUp'
                    variant="borderless"
                    placeholder="Thỏa mãn tất cả các số điều kiện (AND)"
                    suffixIcon={null}
                    options={ConditionGroup}
                    value={infoOperatorTmp.typeCondition}
                    onChange={handleChangeTypeCondition}
                  />

                </div>
                <div className="  h-full d-flex align-center">
                  <DownOutlined className="text-sm text-98A2B3 " />
                </div>
              </div>
            </div>
            <div className="custom-page-css flex flex-col gap-2 flex-1 ">
              <span className='custom-page-css text-base text-344054 font-regular'>Chọn bộ lọc có sẵn</span>
              <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
                <div className="d-flex align-center  w-full">
                  <Select
                    disabled={infoOperatorTmp.typeCondition === CONDITIONGROUP.ALL}
                    showSearch={false}
                    allowClear
                    className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                    popupClassName='position-dropdow custome-select-item h-popUp'
                    variant="borderless"
                    placeholder="Chọn bộ lọc có sẵn."
                    suffixIcon={null}
                    options={sLListFilter}
                    value={infoOperatorTmp.id}
                    onChange={handleChangeSLlistFilter}
                  />

                </div>
                <div className="  h-full d-flex align-center">
                  <DownOutlined className="text-sm text-98A2B3 " />
                </div>
              </div>
            </div>
          </div>
          {infoOperatorTmp.typeCondition === CONDITIONGROUP.ALL ? ' ' :
            infoOperatorTmp.typeCondition === CONDITIONGROUP.AND ?
              <ConditionGroupAnd
                selectableOptions={selectableOptions}
                options={options}
                //mơi

                infoOperatorTmp={infoOperatorTmp}
                setInfoOperatorTmp={setInfoOperatorTmp}
                setSearchListFilter={setSearchListFilter}
              /> :
              <ConditionGroupOther
                selectableOptions={selectableOptions}
                options={options}
                //mơi

                infoOperatorTmp={infoOperatorTmp}
                setSearchListFilter={setSearchListFilter}
                setInfoOperatorTmp={setInfoOperatorTmp}
              />

          }
        </div>
      </Modal >
    </>
  )
}
export default memo(ModalCondition) 
